import {Box, Button, Image} from '@primer/react-brand'

import {ChevronDownIcon} from '@primer/octicons-react'
import {getImageSources} from '@github-ui/swp-core/lib/utils/images'
import {ContentfulHero} from '@github-ui/swp-core/components/contentful/ContentfulHero'

import type {ResourceDetailsPage} from '../../lib/types/contentful'

import styles from './ResourceDetailsPage.module.css'
import {BreadcrumbsList} from '../../components/BreadcrumbsList/BreadcrumbsList'
import {PublishedDate} from '../../components/PublishedDate/PublishedDate'

type HeaderProps = {
  component: ResourceDetailsPage
  breadcrumbs?: Array<{name: string; url: string}>
  contentFormCta?: string
}

const defaultBreadcrumbs = [] as Array<{name: string; url: string}>

export default function Header({breadcrumbs = defaultBreadcrumbs, component, contentFormCta}: HeaderProps) {
  const {hero, featuredImage, publishedDate} = component.fields

  return (
    <header>
      {breadcrumbs.length > 0 ? (
        <Box marginBlockStart={20}>
          <BreadcrumbsList items={breadcrumbs} selectLastItem />
        </Box>
      ) : null}

      <Box
        marginBlockStart={{narrow: 48, regular: 64}}
        borderBlockEndWidth="thin"
        borderColor="muted"
        borderStyle="solid"
      >
        {hero ? <ContentfulHero component={hero} heroClassName={styles.hero} paddingBlockEnd="none" data-hpc /> : null}

        {publishedDate && <PublishedDate publishedDate={publishedDate} />}

        {featuredImage ? (
          <Image
            className={styles.heroImage}
            as="picture"
            src={`${featuredImage.fields.file.url}?fm=webp`}
            sources={getImageSources(featuredImage.fields.file.url, {maxWidth: 1040})}
            alt={featuredImage.fields.description || ''}
            borderRadius="medium"
            loading="lazy"
          />
        ) : null}

        {contentFormCta ? (
          <Button
            className={styles.heroPrimaryButton}
            as="a"
            href="#content-form"
            variant="primary"
            trailingVisual={<ChevronDownIcon />}
            block
          >
            {contentFormCta}
          </Button>
        ) : null}
      </Box>
    </header>
  )
}
